export var FAMILY_MEM_DETAIL = "FAMILY_MEM_DETAIL";
